import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const addToCart = async (seatObj) => {
	const headers = {
		'Content-Type': 'application/json',
	};
	try {
		const response = await axios.post(
			`${API_BASE_URL}/websocket/addSeat`,
			seatObj,
			{
				headers,
				withCredentials: true,
			},
		);
		return response.status === 200;
	} catch (error) {
		console.error('Error websocket/addSeat :', error);
		return false;
	}
};

export const unSelectSeat = async (seats) => {
	try {
		const response = await fetch(`${API_BASE_URL}/websocket/removeSeat`, {
			method: 'POST',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(seats),
		});

		if (!response.ok) {
			console.error(`Failed to unselect seat. Status: ${response.status}`);
			return false;
		}

		return true;
	} catch (error) {
		console.error('Error in unSelectSeat:', error);
		return false;
	}
};

export const patronHoldLoad = async (patronHoldTicket, seatObjects) => {
	const headers = {
		'Content-Type': 'application/json',
	};
	const patronMessage = {
		patronId: patronHoldTicket.patron.id,
		firstName: patronHoldTicket.patron.firstName,
		lastName: patronHoldTicket.patron.lastName,
		patronHoldSeats: seatObjects,
	};
	try {
		const response = await axios.post(
			`${API_BASE_URL}/websocket/patronLoad`,
			patronMessage,
			{
				headers,
				withCredentials: true,
			},
		);
		return response.status === 200;
	} catch (error) {
		console.error('Error websocket/patronLoad :', error);
		return false;
	}
};
